import { defineMessages } from 'react-intl';

export default defineMessages({
  ourTeam: {
    id: 'AboutUs.AboutUsTeamSection.ourTeam',
    defaultMessage: 'Наша Команда:',
  },
});
